import React, {useEffect, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import {useLang} from '../../context/LanguageContext';
import Lottie from 'lottie-react';
import promoAnim from '../../lotties/promo.json'
import SubscriptionCard from "../../components/SubscriptionCard";
import useSubscriptions from "../../hooks/useSubscriptions";
import {useAuth} from "../../context/AuthContext";

const SubscriptionsPage = () => {
  const navigate = useNavigate();
  const { t } = useLang()
  const subscriptions = useSubscriptions();
  const [possibleSubs, setPossibleSubs] = useState([]);
  const {hasPaid, hasVip} = useAuth()

    useEffect(() => {
        setPossibleSubs(() => {
            if(hasPaid && hasVip){
                return subscriptions.filter(sub => sub.usage.includes(3))
            }
            if(hasPaid){
                return subscriptions.filter(sub => sub.usage.includes(2))
            }
            if(hasVip){
                return subscriptions
                    .filter(sub => sub.usage.includes(1))
                    .filter(sub => {
                        return sub.priceId !== process.env.REACT_APP_STRIPE_VIP_PRICE_ID
                    });

            }
            return subscriptions.filter(sub => sub.usage.includes(1))
        })
    }, [subscriptions, hasPaid, hasVip]);

  return (
    <div className="relative min-h-screen bg-[#34495e] p-5">
      <button
        onClick={() => navigate(-1)}
        className="absolute top-5 left-5 px-4 py-2 bg-[#2ecc71] rounded flex items-center space-x-2"
      >
        <FaArrowLeft />
        <span className="text-white">{t('btn.back')}</span>
      </button>

        <div className="max-w-[700px] mx-auto space-y-6">
            <h1 className="text-white font-bold text-center mt-10 -mb-6 flex items-center">
                <Lottie
                    animationData={promoAnim}
                    style={{width: 70, height: 70, marginBottom: 5}}
                />
                {t('subs.title')}
            </h1>

            {possibleSubs.map((sub, idx) => (
                <SubscriptionCard key={idx} sub={sub} showBuy={true}/>
            ))}
            {possibleSubs.length === 0 &&
                <>
                    <p className="flex" />
                    <p className="flex" />
                    <p className="flex" />
                    <p className="flex" />
                    <p className="flex" />
                    <p className="flex" />
                    <h1 className="text-white font-bold text-center mt-36 flex items-center">
                        {t('subs.notAvailable')}
                    </h1>
                </>
            }
        </div>
    </div>
  );
};

export default SubscriptionsPage;
